import React, { useState } from "react";
import { Database } from "lucide-react";
import DataLineageDashboard from "./datalineage";// ERD component
import DataLineageViewer from "./erd";

const DataLineageContainer = () => {
  const [activeTab, setActiveTab] = useState("erd"); // 'erd' or 'objects'

  return (
    <div className="w-full h-screen flex flex-col bg-gray-50 overflow-hidden">
      {/* Header with Tabs */}
<div className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-center h-16 z-30 flex-shrink-0">
        {/* <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg">
            <Database className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-900">Data Lineage</h2>
            <p className="text-sm text-gray-500">
              Visualize data structures and relationships
            </p>
          </div>
        </div> */}

        {/* Tab Buttons */}
        <div className="flex gap-2 bg-gray-100 p-1 rounded-lg">
          <button
            onClick={() => setActiveTab("erd")}
            className={`px-6 py-2 text-sm font-semibold rounded-md transition-all ${
              activeTab === "erd"
                ? "bg-white text-blue-600 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            ERD
          </button>
          <button
            onClick={() => setActiveTab("objects")}
            className={`px-6 py-2 text-sm font-semibold rounded-md transition-all ${
              activeTab === "objects"
                ? "bg-white text-blue-600 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            Objects
          </button>
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 overflow-hidden">
        {activeTab === "erd" ? (
          <DataLineageDashboard />
        ) : (
          <DataLineageViewer />
        )}
      </div>
    </div>
  );
};

export default DataLineageContainer;